import { useEffect, useState } from "react";
import './styles.js';
import { Container } from "./styles.js";
import { personAge } from "../person-age.js";
import { FaImdb } from "react-icons/fa";

export default function About({ person_id, person_details, externalIds, maximized }) {

    console.log(externalIds)

    return (
        <Container maximized={maximized}>
            <section>
                <section>
                    {person_details?.place_of_birth &&
                        <span><i className="icon-margin-right fa-solid fa-earth-americas"></i> {person_details?.place_of_birth}</span>
                    }
                </section>
                {person_details?.birthday &&
                    <span><i className="fa-solid icon-margin-right fa-calendar-days"></i> {person_details?.birthday.slice(8,10)}/{person_details?.birthday.slice(5,7)}/{person_details?.birthday.slice(0,4)}</span>
                }
                {person_details?.deathday &&
                    <span> - <i className="fa-solid icon-margin-right fa-cross"></i> {(person_details?.deathday).slice(8,10)}/{(person_details?.deathday).slice(5,7)}/{(person_details?.deathday).slice(0,4)}</span>
                }
                {person_details?.birthday &&
                    <span> | {personAge(person_details)} Anos</span>
                }
                <section>
                    {person_details?.gender == 1 ?
                        <span><i className="fa-solid icon-margin-right fa-venus"></i> Genero: Feminino</span>
                        : person_details?.gender == 2 ? <span><i className="fa-solid icon-margin-right fa-mars"></i> Genero: Masculino</span>
                        : person_details?.gender == 3 ? <span>Genero: Não binário</span>
                        : ''
                    }
                </section>
            </section>
            <section className="section-biográfia-pessoa">
                <h2> Redes Sociais</h2>
                <div className="redes-sociais-pessoa-sobre">
                    {externalIds?.instagram_id &&
                        <a target="_blank" href={`https://www.instagram.com/${externalIds?.instagram_id}`}><i className="fa-brands fa-instagram"></i></a>
                    }
                    {externalIds?.twitter_id &&
                        <a target="_blank" href={`https://twitter.com/${externalIds?.twitter_id}`}><i class="fa-brands fa-x-twitter"></i></a>
                        
                    }
                    {externalIds?.facebook_id &&
                        <a target="_blank" href={`https://www.facebook.com/${externalIds?.facebook_id}`}><i className="fa-brands fa-facebook"></i></a>
                        
                    }
                    {externalIds?.youtube_id &&
                        <a target="_blank" href={`https://www.youtube.com/${externalIds?.youtube_id}`}><i className="fa-brands fa-youtube"></i></a>
                        
                    }
                    {externalIds?.tiktok_id &&
                        <a target="_blank" href={`https://www.tiktok.com/@${externalIds?.tiktok_id}`}><i className="fa-brands fa-tiktok"></i></a>
                        
                    }
                    {!externalIds?.instagram_id &&
                    !externalIds?.twitter_id &&
                    !externalIds?.facebook_id &&
                    !externalIds?.youtube_id &&
                    !externalIds?.tiktok_id && (
                        <span>Sem redes sociais disponíveis</span>
                    )}
                </div>
            </section>
            {person_details?.biography != '' &&
                <section className="section-biográfia-pessoa">
                    <h2> Biografia</h2>
                    <span>{person_details?.biography}</span>
                </section>
            }
        </Container>
    );
}
